<template>
    <div class="w-full my-28">
        <div class="flex flex-wrap items-center bg-white">
            <div class="ml-16">
                <h1 class="text-5xl font-heading">{{ user.name }} {{ user.last_name }}</h1>
            </div>
        </div>
        <div class="container my-16">
            <div class="flex flex-col w-full">
                <div class="flex px-6 w-full">
                    <div class="form-group mt-4">
                        <label for="type">Tip</label>
                        <span v-text="user.roles[0].display_name"></span>
                    </div>
                    <div class="form-group">
                        <label for="name">Ime</label>
                        <span>{{ user.name }}</span>
                    </div>
                    <div class="form-group">
                        <label for="last_name">Prezime</label>
                        <span>{{ user.last_name }}</span>
                    </div>
                    <div class="form-group ml-auto">
                        <a class="btn primary" :href="route('users.edit', user.id)">Uredi</a>
                    </div>
                </div>
                <div class="flex px-6 w-full">
                    <div class="form-group">
                        <label for="status">Status</label>
                        <span v-if="user.deleted_at">Neaktivan</span>
                        <span v-else>Aktivan</span>
                    </div>
                    <div class="form-group">
                        <label for="status">Email</label>
                        <span>{{ user.email }}</span>
                    </div>
                    <div class="form-group"></div>
                    <div class="form-group ml-auto"></div>
                </div>
            </div>
            <hr class="my-12" />
            <div class="ml-8 mb-16">
                <h1 class="text-2xl font-heading font-bold">Dodjeljeni radni nalozi</h1>
            </div>
            <data-table
                :api-url="route('datatable.projects', { userId })"
                :columns="columns"
                show-end-point="projects"
            ></data-table>
        </div>
    </div>
</template>
<script>
import DataTable from "./DataTable";
export default {
    components: {
        DataTable,
    },

    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
        columns: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            userId: {
                user: this.user.id,
            },
        };
    },

    created() {},
};
</script>
